export const FETCH_FAV_MATCH = "FETCH_FAV_MATCH";
export const REMOVE_FAV_MATCH = "REMOVE_FAV_MATCH";
export const SHOW_ONLY_FAV = "SHOW_ONLY_FAV";
